import { initCaptchaForForm, CaptchaController } from './captcha-v2';
import { postToLeadWithCaptcha as _postToLeadWithCaptcha } from './post-to-lead-with-captcha';

type CmsFormEntry = {
  controller: CaptchaController;
  requireCaptcha: boolean;
};

const controllerMap = new WeakMap<HTMLFormElement, CmsFormEntry>();

export function initCmsCaptchaForms(): void {
  document.querySelectorAll<HTMLFormElement>('form.captcha-enabled').forEach(form => {
    const mount = form.querySelector<HTMLElement>('.captaincaps');
    if (!mount) {
      return;
    }

    const submitButton = form.querySelector<HTMLElement>('[type="submit"], .submitter');
    const emailInput = form.querySelector<HTMLInputElement>('input[type="email"]');
    const locale = document.documentElement.lang === 'en' ? 'en' : 'de';

    const { controller, requireCaptchaOnSubmit } = initCaptchaForForm({
      form,
      mountElement: mount,
      emailInput,
      locale,
      onShowWidget: () => {
        mount.classList.remove('is-hidden');
        submitButton?.classList.add('is-hidden');
      },
      onHideWidget: () => {
        mount.classList.add('is-hidden');
        submitButton?.classList.remove('is-hidden');
      }
    });

    if (!controller) {
      return;
    }

    controllerMap.set(form, { controller, requireCaptcha: requireCaptchaOnSubmit });

    form.addEventListener('input', () => {
      if (!controller.hasUsableToken()) {
        controller.startIfNeeded();
      }
    }, { once: true });
  });
}

export function getCaptchaToken(form: HTMLFormElement): string | undefined {
  return controllerMap.get(form)?.controller.getToken();
}

export async function postToLeadWithCaptcha(
  path: string,
  payload: Record<string, any>,
  form: HTMLFormElement
) {
  const entry = controllerMap.get(form);
  return _postToLeadWithCaptcha(path, payload, {
    captcha: entry?.controller,
    requireCaptcha: entry?.requireCaptcha ?? false
  });
}
